/* By Lilo — conversie-fixes: mobiele sticky add-to-cart, gratis-verzendbalk, cart
   cross-sell ("Vaak erbij gekocht") en vangnetten voor dode einden (404, lege cart,
   nul zoekresultaten). NL/DE locale-bewust. Additief; leunt op bestaande Dawn
   cart-drawer. Verwijderbaar via dit bestand + de include in snippets/meta-tags.liquid. */
(function () {
  'use strict';

  var LANG = (document.documentElement.lang || '').toLowerCase();
  var DE = LANG.indexOf('de') === 0;
  var FR = LANG.indexOf('fr') === 0;
  var FREE_SHIP_MIN = 5000; // cents: EUR 50 in alle markten (NL, BE, DE, FR)
  var T_NL = {
    fsbLeft1: 'Nog ', fsbLeft2: ' tot gratis verzending',
    fsbDone: 'Gefeliciteerd, je hebt <b>gratis verzending</b>!',
    xsellHead: 'Vaak erbij gekocht', add: '+ Toevoegen', adding: 'Toevoegen…', added: 'Toegevoegd ✓',
    addAria: 'Voeg ', addAria2: ' toe aan winkelwagen',
    rescueHead: 'Onze bestsellers', rescueView: 'Bekijk',
    sizeFrom: /^\s*Accessoiregrootte\s*:/i, sizeTo: 'Kies je maat:',
    badges: null, cta: null
  };
  var T_DE = {
    fsbLeft1: 'Noch ', fsbLeft2: ' bis zum Gratisversand',
    fsbDone: 'Geschafft! Du hast <b>Gratisversand</b>',
    xsellHead: 'Wird oft dazu gekauft', add: '+ Hinzufügen', adding: 'Hinzufügen…', added: 'Hinzugefügt ✓',
    addAria: 'Lege ', addAria2: ' in den Warenkorb',
    rescueHead: 'Unsere Bestseller', rescueView: 'Ansehen',
    sizeFrom: /^\s*Zubehörgröße\s*:/i, sizeTo: 'Wähle deine Größe:',
    badges: { 'setkorting': 'Set-Rabatt', 'led-collectie': 'LED-Kollektion', 'nieuw': 'Neu', 'bestseller': 'Bestseller', 'glow': 'Glow' },
    cta: 'Ansehen'
  };
  var T_FR = {
    fsbLeft1: 'Encore ', fsbLeft2: ' pour la livraison gratuite',
    fsbDone: 'Bravo, tu as la <b>livraison gratuite</b> !',
    xsellHead: 'Souvent acheté avec', add: '+ Ajouter', adding: 'Ajout…', added: 'Ajouté ✓',
    addAria: 'Ajoute ', addAria2: ' au panier',
    rescueHead: 'Nos best-sellers', rescueView: 'Voir',
    sizeFrom: /^\s*Taille\s+(?:d['’]accessoire|des accessoires)\s*:/i, sizeTo: 'Choisis ta taille :',
    badges: { 'setkorting': 'Réduction lot', 'led-collectie': 'Collection LED', 'nieuw': 'Nouveau', 'bestseller': 'Best-seller', 'glow': 'Glow' },
    cta: 'Voir'
  };
  var T = DE ? T_DE : (FR ? T_FR : T_NL);
  var injecting = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function euro(cents) {
    return '€' + (Math.abs(cents) / 100).toFixed(2).replace('.', ',');
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  /* ---------------- Gratis-verzendbalk ---------------- */
  function buildFsb(id, subtotal) {
    var remaining = FREE_SHIP_MIN - subtotal;
    var pct = Math.max(0, Math.min(100, (subtotal / FREE_SHIP_MIN) * 100));
    var done = remaining <= 0;
    var wrap = el('div', 'bl-fsb' + (done ? ' bl-fsb--done' : ''));
    wrap.id = id;
    var msg = done
      ? '<span aria-hidden="true">🎉</span> ' + T.fsbDone
      : '<span aria-hidden="true">🐾</span> ' + T.fsbLeft1 + '<b>' + euro(remaining) + '</b>' + T.fsbLeft2;
    wrap.appendChild(el('div', 'bl-fsb__msg', msg));
    var track = el('div', 'bl-fsb__track');
    var fill = el('div', 'bl-fsb__fill');
    fill.style.width = pct + '%';
    track.appendChild(fill);
    wrap.appendChild(track);
    return wrap;
  }

  /* ---------------- Cross-sell ---------------- */
  function fetchRecs(productId, cartIds, cb) {
    var base = root() + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=';
    fetch(base + 'complementary')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d && d.products) || [];
        list = list.filter(function (p) { return cartIds.indexOf(p.id) === -1; });
        if (list.length) { cb(list); return; }
        fetch(base + 'related')
          .then(function (r) { return r.json(); })
          .then(function (d2) {
            var l2 = ((d2 && d2.products) || []).filter(function (p) { return cartIds.indexOf(p.id) === -1; });
            cb(l2);
          })
          .catch(function () { cb([]); });
      })
      .catch(function () { cb([]); });
  }

  function firstAvailableVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i]; }
    return vs[0] || null;
  }

  function buildXsell(id, products) {
    var wrap = el('div', 'bl-xsell');
    wrap.id = id;
    wrap.appendChild(el('div', 'bl-xsell__head', T.xsellHead));
    products.slice(0, 2).forEach(function (p) {
      var v = firstAvailableVariant(p);
      if (!v) return;
      var item = el('div', 'bl-xsell__item');
      var img = p.featured_image || (p.images && p.images[0]) || '';
      item.appendChild(el('img', 'bl-xsell__img', '')).src = img;
      var meta = el('div', 'bl-xsell__meta');
      meta.appendChild(el('div', 'bl-xsell__name', p.title));
      meta.appendChild(el('div', 'bl-xsell__price', '<b>' + euro(v.price) + '</b>'));
      item.appendChild(meta);
      var btn = el('button', 'bl-xsell__add');
      btn.type = 'button';
      btn.textContent = T.add;
      btn.setAttribute('aria-label', T.addAria + p.title + T.addAria2);
      btn.addEventListener('click', function () { quickAdd(v.id, btn); });
      item.appendChild(btn);
      wrap.appendChild(item);
    });
    return wrap.querySelector('.bl-xsell__item') ? wrap : null;
  }

  function quickAdd(variantId, btn) {
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = T.adding;
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.querySelector('#main-cart-footer');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (drawer && !onCartPage && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || (root() + 'cart/add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.textContent = T.added;
        if (onCartPage) { setTimeout(function () { window.location.reload(); }, 350); return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
          if (typeof drawer.open === 'function') drawer.open();
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bylilo-xsell' });
        }
        setTimeout(injectCartUI, 150);
      })
      .catch(function () { btn.disabled = false; btn.textContent = original; });
  }

  /* ---------------- Inject into cart surfaces ---------------- */
  function placeFsb(container, id, cart) {
    if (!container) return;
    var old = container.querySelector('#' + id); if (old) old.remove();
    if (!cart || cart.item_count === 0) return;
    container.insertBefore(buildFsb(id, cart.items_subtotal_price), container.firstChild);
  }

  function placeXsell(container, id, cart, beforeSel) {
    if (!container) return;
    var old = container.querySelector('#' + id); if (old) old.remove();
    if (!cart || cart.item_count === 0) return;
    var pid = cart.items[0] && cart.items[0].product_id;
    if (!pid) return;
    var cartIds = cart.items.map(function (i) { return i.product_id; });
    fetchRecs(pid, cartIds, function (products) {
      if (!products.length) return;
      if (container.querySelector('#' + id)) return;
      var node = buildXsell(id, products);
      if (!node) return;
      var anchor = beforeSel ? container.querySelector(beforeSel) : null;
      container.insertBefore(node, anchor || null);
    });
  }

  function injectCartUI() {
    if (injecting) return;
    injecting = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Drawer: gratis-verzendbalk klein in de footer (dicht bij de knop), maar de
        // cross-sell in de SCROLLBARE itemzone — anders duwt die de afrekenknop uit beeld.
        placeFsb(document.querySelector('cart-drawer .drawer__footer'), 'bl-fsb-drawer', cart);
        placeXsell(
          document.querySelector('cart-drawer #CartDrawer-CartItems') || document.querySelector('cart-drawer-items'),
          'bl-xsell-drawer', cart, null
        );
        // Cart-pagina (scrollt als normale pagina): beide in de footer is prima.
        placeFsb(document.querySelector('#main-cart-footer .cart__footer'), 'bl-fsb-cart', cart);
        placeXsell(document.querySelector('#main-cart-footer .cart__footer'), 'bl-xsell-cart', cart, '.cart__blocks');
      })
      .catch(function () {})
      .then(function () { injecting = false; });
  }

  /* ---------------- Vangnet: bestsellers op dode einden ---------------- */
  function buildRescue(id) {
    var wrap = el('div', 'bl-rescue');
    wrap.id = id;
    wrap.appendChild(el('div', 'bl-rescue__head', T.rescueHead));
    var row = el('div', 'bl-rescue__row');
    wrap.appendChild(row);
    fetch(root() + 'products.json?limit=4')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d && d.products) || [];
        if (!ps.length) { wrap.remove(); return; }
        ps.slice(0, 4).forEach(function (p) {
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          var price = p.variants && p.variants[0] ? p.variants[0].price : '';
          if (price) price = '€' + String(price).replace('.', ',');
          var card = el('a', 'bl-rescue__card');
          card.href = root().replace(/\/$/, '') + '/products/' + p.handle;
          card.innerHTML = '<img src="' + img + '&width=400" alt="" loading="lazy">' +
            '<span class="bl-rescue__name">' + p.title + '</span>' +
            '<span class="bl-rescue__price">' + price + '</span>' +
            '<span class="bl-rescue__cta">' + T.rescueView + '</span>';
          row.appendChild(card);
        });
      })
      .catch(function () { wrap.remove(); });
    return wrap;
  }

  function injectRescues() {
    var body = document.body;
    // 404-pagina
    if (body.classList.contains('template-404') && !document.querySelector('#bl-rescue-404')) {
      var main404 = document.querySelector('#MainContent');
      if (main404) main404.appendChild(buildRescue('bl-rescue-404'));
    }
    // Nul zoekresultaten
    if (body.classList.contains('template-search') && !document.querySelector('#bl-rescue-search')) {
      var noResults = !document.querySelector('#product-grid, .search-results, [id*="ProductGrid"] .grid__item');
      var statusText = (document.querySelector('#MainContent') || {}).textContent || '';
      if (noResults && /Geen resultaten|No results|Keine Ergebnisse/i.test(statusText)) {
        var mainS = document.querySelector('#MainContent');
        if (mainS) mainS.appendChild(buildRescue('bl-rescue-search'));
      }
    }
    // Lege winkelwagen-pagina
    if (body.classList.contains('template-cart') && !document.querySelector('#bl-rescue-cart')) {
      var emptyEl = document.querySelector('.cart__warnings, .is-empty .cart__empty-text');
      if (emptyEl) {
        var mainC = document.querySelector('#MainContent');
        if (mainC) mainC.appendChild(buildRescue('bl-rescue-cart'));
      }
    }
  }

  /* ---------------- Mobiele sticky add-to-cart ---------------- */
  function initSticky() {
    var buyBtn = document.querySelector('.bl-buy-btn');
    if (!buyBtn || document.querySelector('.bl-sticky-atc')) return;
    var titleEl = document.querySelector('.bl-pdp h1');
    var priceEl = document.querySelector('[data-bl-price]');
    var labelEl = buyBtn.querySelector('[data-bl-buy-label]');

    var bar = el('div', 'bl-sticky-atc');
    var info = el('div', 'bl-sticky-atc__info');
    var t = el('span', 'bl-sticky-atc__title', titleEl ? titleEl.textContent : '');
    var pr = el('span', 'bl-sticky-atc__price', priceEl ? priceEl.textContent : '');
    info.appendChild(t); info.appendChild(pr);
    var btn = el('button', 'bl-sticky-atc__btn');
    btn.type = 'button';
    btn.textContent = labelEl ? labelEl.textContent.trim() : 'In winkelwagen';
    btn.addEventListener('click', function () { buyBtn.click(); });
    bar.appendChild(info); bar.appendChild(btn);
    document.body.appendChild(bar);

    function sync() {
      if (priceEl) pr.textContent = priceEl.textContent;
      var disabled = buyBtn.hasAttribute('disabled');
      btn.disabled = disabled;
      if (labelEl) btn.textContent = labelEl.textContent.trim();
    }
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(buyBtn, { attributes: true, childList: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
      }, { threshold: 0 }).observe(buyBtn);
    }
  }

  /* ---------------- Microcopy: vriendelijker maatlabel (NL + DE) ---------------- */
  function fixMicrocopy() {
    var labels = document.querySelectorAll('.bl-variants__label');
    labels.forEach(function (l) {
      if (T.sizeFrom.test(l.textContent)) {
        l.innerHTML = l.innerHTML.replace(T.sizeFrom, T.sizeTo);
      }
    });
  }

  // Vertaal de productkaart-/PDP-badges + kaart-CTA (uit NL metafields/defaults) naar Duits.
  function fixBadges() {
    if (!T.badges) return;
    document.querySelectorAll('.bl-card__badge, .bl-pdp__badge').forEach(function (b) {
      var key = (b.textContent || '').trim().toLowerCase();
      if (T.badges[key]) b.textContent = T.badges[key];
    });
    if (T.cta) {
      document.querySelectorAll('.bl-card__cta').forEach(function (c) {
        if (/^\s*Bekijk\s*$/.test(c.textContent)) c.textContent = T.cta;
      });
    }
  }

  /* ---------------- Triggers ---------------- */
  var _fetch = window.fetch;
  window.fetch = function () {
    var p = _fetch.apply(this, arguments);
    try {
      var a0 = arguments[0];
      var url = (a0 && a0.url) || String(a0 || '');
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function () { setTimeout(injectCartUI, 140); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  /* ---------------- Contactformulier — botfilter ---------------- */
  /* Twee drempels tegen formulier-spam. Beide client-side: de server-side laag is
     Shopify's eigen reCAPTCHA (Online Store → Preferences → Spam protection).
     1. Honeypot: het verborgen veld #bl-website vult geen mens ooit in.
     2. Tijdslot: bots posten binnen een fractie van een seconde na het laden. */
  var MIN_FILL_MS = 3000;

  function initContactGuard() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var loadedAt = Date.now();
    var released = false;

    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('#bl-website');
      if (hp && hp.value) {
        // Stille nep-succes: de bot denkt dat het gelukt is en probeert het niet opnieuw.
        e.preventDefault();
        if (!form.querySelector('.bl-contact__success')) {
          var ok = el('div', 'bl-contact__success', '&#128062; ' + (DE ? 'Danke! Deine Nachricht ist unterwegs.' : 'Bedankt! Je bericht is onderweg.'));
          form.insertBefore(ok, form.firstChild);
        }
        form.reset();
        return;
      }
      if (released) return;
      if (Date.now() - loadedAt < MIN_FILL_MS) {
        // Te snel ingediend. Niet weigeren — uitstellen, zodat een echte bezoeker niets merkt.
        e.preventDefault();
        setTimeout(function () {
          released = true;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }, MIN_FILL_MS - (Date.now() - loadedAt));
      }
    });
  }

  /* ---------------- E-mailadressen ontsleutelen ---------------- */
  /* Het adres staat gesplitst in data-u/data-d, dus nooit als aaneengesloten
     string in de HTML-bron. Bewust NIET klikbaar: klanten gaan via het
     contactformulier, en een mailto-link levert vooral spam op. */
  function initObfuscatedMails() {
    var nodes = document.querySelectorAll('.bl-mail[data-u][data-d]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.firstChild) continue;
      n.textContent = n.getAttribute('data-u') + '@' + n.getAttribute('data-d');
    }
  }

  function boot() {
    initContactGuard();
    initObfuscatedMails();
    injectCartUI();
    initSticky();
    fixMicrocopy();
    fixBadges();
    injectRescues();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(injectCartUI, 140); });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (injecting) return;
        if (!document.querySelector('#bl-fsb-drawer')) setTimeout(injectCartUI, 60);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
